/**
 * DEALER_ANALYST
 */

export default (() => {
  return {
    DEALER_ANALYST: {
      defaultSelectedId: ["Reports"],
      items: [
        {
          id: "Reports",
          name: "Отчеты",
          icon: "bar-chart",
          path: "/reports",
        },
        {
          id: "News",
          name: "Новости",
          icon: "exclamation-circle",
          path: "/news",
        },
        {
          id: "Settings",
          name: "Настройки",
          icon: "setting",
          children: {
            items: [
              {
                id: "NotificationSettings",
                name: "Уведомления",
                path: "/notification-settings",
              },
            ],
          },
        },
      ],
    },
  }
})()
